/* 获取时间段内属于星期一(*)的日期们
 * begin: 开始时间
 * end：结束时间
 * weekNum：星期几 {number}
 */
function getWeek(begin, end, weekNum) {
  const dateArr = [];
  const stimeArr = begin.split('-'); //=>["2018", "01", "01"]
  const etimeArr = end.split('-'); //=>["2018", "01", "30"]

  const stoday = new Date();
  stoday.setUTCFullYear(stimeArr[0], stimeArr[1] - 1, stimeArr[2]); //setUTCFullYear() 方法用于根据世界时 (UTC) 设置年份
  const etoday = new Date();
  etoday.setUTCFullYear(etimeArr[0], etimeArr[1] - 1, etimeArr[2]);

  const unixDb = stoday.getTime(); //开始时间的毫秒数
  const unixDe = etoday.getTime(); //结束时间的毫秒数

  for (let k = unixDb; k <= unixDe; ) {
    // eslint-disable-next-line radix
    let needJudgeDate = msToDate(parseInt(k)).withoutTime;
    //不加这个if判断直接push的话就是已知时间段内的所有日期
    if (new Date(needJudgeDate).getDay() === weekNum) {
      dateArr.push({ date: needJudgeDate, week: weekNum });
    }
    k = k + 24 * 60 * 60 * 1000;
  }
  return dateArr;
}

//根据毫秒数获取日期
function msToDate(msec) {
  let dateTime = new Date(msec);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth();
  let date = dateTime.getDate();
  let hour = dateTime.getHours();
  let minute = dateTime.getMinutes();
  let second = dateTime.getSeconds();

  let hasTime =
    year +
    '-' +
    (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
    '-' +
    (date + 1 < 10 ? '0' + date : date) +
    ' ' +
    (hour + 1 < 10 ? '0' + hour : hour) +
    ':' +
    (minute + 1 < 10 ? '0' + minute : minute) +
    ':' +
    (second + 1 < 10 ? '0' + second : second);

  let withoutTime =
    year +
    '-' +
    (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
    '-' +
    (date + 1 < 11 ? '0' + date : date);

  let result = {
    hasTime,
    withoutTime,
  };

  return result;
}

function dateFormat(format) {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  if (format === 'yyyy-MM-dd') {
    return `${year}-${month < 10 ? '0' + month : month}-${
      day < 10 ? '0' + day : day
    }`;
  } else if (format === 'yyyy-MM-dd hh:mm:ss') {
    return `${year}-${month < 10 ? '0' + month : month}-${
      day < 10 ? '0' + day : day
    } ${hours < 10 ? '0' + hours : hours}:${
      minutes < 10 ? '0' + minutes : minutes
    }:${seconds < 10 ? '0' + seconds : seconds}`;
  }
}

//获取任意一天的开始时间
function startTime(time) {
  const nowTimeDate = new Date(time);
  return nowTimeDate.setHours(0, 0, 0, 0);
}

//获取任意一天结束时间
function endTime(time) {
  const nowTimeDate = new Date(time);
  return nowTimeDate.setHours(23, 59, 59, 999);
}

export { getWeek, dateFormat, startTime, endTime };
